import Login from "./Login";
import styles from "../../assets/stylesheets/sass/InfoFiche/PublicInfoFiche.module.scss"
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { Document, Page, pdfjs   } from "react-pdf";
import axios from 'axios';
import { X } from "lucide-react";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const PublicInfoFiche = () => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams();


    const [page_state, setpage_state] = useState("loading")
    const [fitdoc_document, setfitdoc_document] = useState(null);
    const [numPages, setNumPages] = useState(null);

    useEffect(()=>{
        const code = searchParams.get('code');
        if(code){
            //LATosYXywA
            getInfofiche(code)
            //getDocument(code)
        }
        else {
            navigate('/')
        }
    }, [])

    const getInfofiche = async (code) => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_SERVER_LINK}anonymouslink?code=${code}`)
            if(data.errorcode === 0){
                if(Array.isArray(data.object.docids)){
                    const document = await getDocument(data.object.docids[0])
                    if(document.errorcode === 0){
                        setfitdoc_document(document.object)
                        setpage_state('loaded')
                        console.log(document)
                    }
                    else {
                        setpage_state('error')
                    }
                }
                else {
                    setpage_state('error')
                }
            }
            else {
                setpage_state('error')
            }
        } catch (error) {
            console.log(error)
            setpage_state('error')
        }
    }

    const getDocument = async (docid) => {
        try {   
            let f = await fetch(`${process.env.REACT_APP_SERVER_LINK}documents?docid=${docid}&token=${process.env.REACT_APP_FITDOC_TOKEN}`)
            const doc = await f.json();
            return doc;

        } catch (error) {
            console.log(error)
            return ({errorcode:1, message:'Something went wrong'})
        }
    }

    const downloadDocument = () => {
        const link = document.createElement('a');
        link.download = fitdoc_document.filename;
        link.href = "data:application/octet-stream;base64," + fitdoc_document.file;
        link.click();
    }
    
    return (
        <>
        <div className={styles.popup}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <div className="flex items-center -translate-x-4 gap-2">
                        <button onClick={()=>{navigate('/')}} className="flex justify-center items-center w-8 h-8 rounded-sm text-neutral-500 hover:text-neutral-600"><X /></button>
                        <div>
                            <p className={styles.title}>{fitdoc_document && fitdoc_document.filename}</p>
                            <p className={styles.date}>Info Fiche</p>
                        </div>
                    </div>

                    <div>
                        {page_state === "loaded" && 
                        <button onClick={()=>{downloadDocument()}} className='bg-green-700 text-white px-3 py-4 font-medium hover:bg-green-800 duration-100'>Document downloaden</button>
                        }
                    </div>
                </div>
                
                {page_state === "loading" &&
                <div className='flex flex-col justify-center items-center p-8'>
                    <h2 className="text-xl font-bold">Even geduld</h2>
                    <p className="text-neutral-600">Ik haal uw document op...</p>
                </div>
                }

                {page_state === "error" &&
                <div className='flex flex-col justify-center items-center p-8'>
                    <h2 className="text-xl font-bold">Helaas...</h2>
                    <p className="text-neutral-600">Ik kon uw document niet terug vinden.</p>
                </div>
                }

                {page_state === "loaded" &&
                <div className={styles.document}>
                    <Document
                    onLoadSuccess={({ numPages })=>setNumPages(numPages)}
                    file={"data:application/pdf;base64,"+fitdoc_document.file}
                    >
                        {Array.apply(null, Array(numPages))
                        .map((x, i)=>i+1)
                        .map(page => <div key={page} style={{marginBottom:"1.5rem"}}><Page pageNumber={page}/></div>)}
                        
                    </Document>
                </div>
                }
                
            </div>
        </div>

        <Login language={"N"}/>
        </>
    )
}

export default PublicInfoFiche;